var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.25H5C3.48 3.25 2.25 4.48 2.25 6V18C2.25 19.52 3.48 20.75 5 20.75H12C13.52 20.75 14.75 19.52 14.75 18V6C14.75 4.48 13.52 3.25 12 3.25ZM13.25 18C13.25 18.69 12.69 19.25 12 19.25H5C4.31 19.25 3.75 18.69 3.75 18V6C3.75 5.31 4.31 4.75 5 4.75H12C12.69 4.75 13.25 5.31 13.25 6V18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.25C17.48 3.25 16.25 4.48 16.25 6V16.39C16.25 16.93 16.41 17.46 16.71 17.92L18.37 20.42C18.51 20.63 18.74 20.75 18.99 20.75C19.24 20.75 19.48 20.62 19.61 20.42L21.27 17.92C21.57 17.47 21.73 16.94 21.73 16.39V6C21.73 4.48 20.5 3.25 18.98 3.25H19ZM19 4.75C19.69 4.75 20.25 5.31 20.25 6V7.25H17.75V6C17.75 5.31 18.31 4.75 19 4.75ZM20.04 17.09L19 18.65L17.96 17.09C17.82 16.88 17.75 16.64 17.75 16.4V8.76H20.25V16.4C20.25 16.65 20.18 16.89 20.04 17.09Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.25H6C5.59 8.25 5.25 8.59 5.25 9C5.25 9.41 5.59 9.75 6 9.75H11C11.41 9.75 11.75 9.41 11.75 9C11.75 8.59 11.41 8.25 11 8.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25H6C5.59 11.25 5.25 11.59 5.25 12C5.25 12.41 5.59 12.75 6 12.75H10C10.41 12.75 10.75 12.41 10.75 12C10.75 11.59 10.41 11.25 10 11.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.25H6C5.59 14.25 5.25 14.59 5.25 15C5.25 15.41 5.59 15.75 6 15.75H9C9.41 15.75 9.75 15.41 9.75 15C9.75 14.59 9.41 14.25 9 14.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartDateIcon);
export default __webpack_public_path__ + "static/media/start_date_icon.0b3f3b757c35f288a6ebceb397808ac4.svg";
export { ForwardRef as ReactComponent };